function sumArray(array: number[]) {
    return array.reduce((sum: number, val: number) => sum + val, 0);
}

function insertMultipleValuesIntoRow(row: number[], count: number, value: number) {
    const itemsToInsert = Array(count).fill(value);
    row.splice(row.length, 0, ...itemsToInsert);
}

function addCombination(matrix: number[][], maxCapacity: number, width: number, indexWidth: number) {
    for (let indexRow = matrix.length, j = maxCapacity; j > 0; indexRow++, j--) {
        if (indexWidth == 0) {
            matrix[indexRow] = [];
            insertMultipleValuesIntoRow(matrix[indexRow], j, width);
            break;
        }
        matrix[indexRow] = [];
        insertMultipleValuesIntoRow(matrix[indexRow], j, width);
    }
}

function getBorderIndex(matrix: number[][], total: number) {
    for(let border = matrix.length - 1; border >= 0 ;border--) {
        if(sumArray(matrix[border]) > total) {
            return border;
        }
    }
    return -1;
}

function isUniquePrefixPresent(needle: number[], haystack: number[][]) {
    for (const item of haystack) {
        if (areArraysEqual(item, needle)) {
            return false;
        }
    }
    return true;
}

function areArraysEqual(arr1: number[], arr2: number[]) {
    if (arr1.length !== arr2.length) {
        return false;
    }

    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }

    return true;
}

function generateMatrixOfCombinations(totalShelfWidth: number, railWidth: number[], index: number, matrix: number[][]) {
    let maxCapacity: number;
    if (matrix.length == 0) {
        maxCapacity = Math.ceil(totalShelfWidth/railWidth[index])*railWidth[index] > totalShelfWidth ?
                                    Math.ceil(totalShelfWidth/railWidth[index]) : Math.ceil(totalShelfWidth/railWidth[index]) + 1;
        addCombination(matrix, maxCapacity, railWidth[index], index);

        return matrix;
    }

    const startSizeMatrix: number = matrix.length;
    const startBorder: number = getBorderIndex(matrix, totalShelfWidth);
    const uniquePrefixesArray: number[][] = [];
    let countElementsForAdd: number;

    for (let indexRow = 0; indexRow < startSizeMatrix; indexRow++) {
        if (sumArray(matrix[indexRow]) <= totalShelfWidth) {
            countElementsForAdd =   Math.ceil((totalShelfWidth - sumArray(matrix[indexRow]))/railWidth[index])*railWidth[index] + sumArray(matrix[indexRow]) > totalShelfWidth ?
                                    Math.ceil((totalShelfWidth - sumArray(matrix[indexRow]))/railWidth[index]) : Math.ceil((totalShelfWidth - sumArray(matrix[indexRow]))/railWidth[index]) + 1;
            insertMultipleValuesIntoRow(matrix[indexRow], countElementsForAdd, railWidth[index]);
        }

        if (!matrix[indexRow].includes(railWidth[index]) && startBorder > indexRow) {
            const baseRow: number[] = matrix[indexRow].slice(0);

            while(baseRow.length > 1) {
                baseRow.pop();
                const currentRow: number[] = baseRow.slice(0);

                if(isUniquePrefixPresent(currentRow, uniquePrefixesArray)) {
                    uniquePrefixesArray.push(baseRow.slice(0));
                    countElementsForAdd =   Math.ceil((totalShelfWidth - sumArray(baseRow))/railWidth[index])*railWidth[index] + sumArray(baseRow) > totalShelfWidth ?
                                            Math.ceil((totalShelfWidth - sumArray(baseRow))/railWidth[index]) : Math.ceil((totalShelfWidth - sumArray(baseRow))/railWidth[index]) + 1;
                    matrix[matrix.length] = currentRow;
                    insertMultipleValuesIntoRow(currentRow, countElementsForAdd, railWidth[index]);
                }
            }

        }
    }
    maxCapacity =   Math.ceil(totalShelfWidth/railWidth[index])*railWidth[index] > totalShelfWidth ?
                    Math.ceil(totalShelfWidth/railWidth[index]) : Math.ceil(totalShelfWidth/railWidth[index]) + 1;
    addCombination(matrix, maxCapacity, railWidth[index], index);

    return matrix;
}

export function getOptimalRailSet(totalShelfWidth: number, railWidth: number[], index: number = railWidth.length - 1, matrix: number[][] = []): number[] {
    if (index >= 0) {
        matrix = generateMatrixOfCombinations(totalShelfWidth, railWidth, index, matrix);
        railWidth.pop();
        index--;

        return getOptimalRailSet(totalShelfWidth, railWidth, index, matrix);
    }

    let minCombination: number[] = matrix[0];
    for (let i = 1; i < matrix.length; i++) {
        if (sumArray(matrix[i]) < sumArray(minCombination)) {
            minCombination = matrix[i];
        }
    }

    return minCombination;
}
